import { Component } from 'react'
import { Redemption } from 'interfaces/bounty'
import Table2, { TableContextType, TableContext } from 'components/molecules/tables/Table2'
import { formatUSCurrency } from 'helpers/formatHelpers'
import TableNoWrapValue from 'components/atoms/tables/TableNoWrapValue'
import { formatUSDate } from 'helpers/dateTimeHelpers'
import AccountBadge from 'components/features/pfm/AccountBadge/AccountBadge'
import withContext from 'hocs/withContext/withContext'

type RowProps = {
  table: TableContextType
  row: Redemption
}

class RedemptionsModuleRow extends Component<RowProps> {
  render () {
    const { row } = this.props
    const {
      account,
      amount,
      date,
    } = row

    const rowKey = this.props.table.getRowKey(row)

    return (
      <Table2.Row key={ rowKey }>
        <Table2.Cell rowKey={ rowKey } name='date'>
          { formatUSDate(date) }
        </Table2.Cell>
        <Table2.Cell rowKey={ rowKey } name='account'>
          <AccountBadge
            name={ account.name }
            cardNumber={ account.account_number4 }
          />
        </Table2.Cell>
        <Table2.Cell rowKey={ rowKey } name='amount'>
          <TableNoWrapValue>{ formatUSCurrency(amount, 'penny') }</TableNoWrapValue>
        </Table2.Cell>
      </Table2.Row>
    )
  }
}

export default withContext(TableContext, 'table')(RedemptionsModuleRow)
